/**
 * Copyright 2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deleteAPIKey = `mutation DeleteAPIKey($customer_id: String!, $id: String!) {
  deleteAPIKey(customer_id: $customer_id, id: $id)
}
`;
